import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ClientRegistration from "./ClientRegistration";
import InsuranceCompanyDetails from "../PolicyManagement/InsuranceCompanyDetails";
import InsuranceCompanyEmployeeRegistration from "./InsuranceCompanyEmployeeRegistration";
import InternalEmployeeRegistration from "./InternalEmployeeRegistration";
import Colors from "../../theme/colors.json";

const useStyles = makeStyles((theme) => ({
  contactRegisterContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",

    "@media (min-width: 1000px) and (max-width: 1500px)": {
      padding: "1%  0 2% 0",
    },
    "@media (min-width: 600px) and (max-width: 1000px)": {
      padding: "6%  0 2% 0",
    },
    "@media (max-width: 600px)": {
      padding: "10%  0 2% 0",
    },
  },
  tabsContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    paddingTop: "3%",
    paddingBottom: "1%",
  },
  contactRegisterTabs: {
    borderRadius: "0.5rem 0.5rem 0.5rem 0.5rem",
    background: Colors.WHITE_BACKGROUND,
    "&.MuiTabs-root .MuiTabScrollButton-root svg": {
      color: theme.palette.secondary.main,
    },
    "&.MuiTabs-root .MuiTabs-indicator": {
      backgroundColor: theme.palette.primary.main,
      height: "8%",
      borderRadius: "0.5vw 0.5vw 0 0",
    },
  },
  contactRegistrationTab: {
    textTransform: "capitalize",
    // color: "white !important",
    "&.Mui-selected": {
      // backgroundColor: theme.palette.secondary.main,
      color: `${theme.palette.primary.main} !important`,
      fontSize: theme.fontSizes.SMALL,
      fontWeight: 700,
    },
  },
  customDialog: {
    "& .MuiDialog-paper": {
      maxWidth: "unset",
    },
  },
  tabsTableContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  tabsTableSection: {
    width: "70%",
  },
  tabsSection: {
    width: "70%",
  },
  contactRegisterHeading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "1.3rem",
    fontWeight: 600,
    color: theme.palette.secondary.main,
    paddingBottom: 10,
  },
}));

function ContactRegistration() {
  const classes = useStyles();

  const [tabvalue, setTabValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleTabSwitching = (tab) => {
    switch (tab) {
      case 0:
        return (
          <div className={classes.tabsTableSection}>
            <ClientRegistration />
          </div>
        );
      case 1:
        return (
          <div className={classes.tabsTableSection}>
            <InsuranceCompanyEmployeeRegistration />
          </div>
        );
      case 2:
        return (
          <div className={classes.tabsTableSection}>
            <InternalEmployeeRegistration />
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className={classes.contactRegisterContainer}>
      <div className={classes.tabsContainer}>
        <div className={classes.tabsSection}>
          {/* <div className={classes.contactRegisterHeading}>Registration</div> */}
          <Tabs
            id="Product-Register-Tabs"
            value={tabvalue}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            className={classes.contactRegisterTabs}
          >
            <Tab className={classes.contactRegistrationTab} label="Client" />
            <Tab
              className={classes.contactRegistrationTab}
              label="Insurer Employee"
            />
            <Tab
              className={classes.contactRegistrationTab}
              label="Internal Employee"
            />
          </Tabs>
        </div>
      </div>
      <div className={classes.tabsTableContainer}>
        {handleTabSwitching(tabvalue)}
      </div>
    </div>
  );
}

export default ContactRegistration;
